import * as React from "react";

const SvgComponent = ({ fill = "#000", stroke = "#636F7C", ...props }) => (
  <svg
    width={30}
    height={30}
    fill={props.color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={29} height={29} rx={5.5} stroke={stroke} />
    <path
      d="M23.2 19.35v-1.6h.6c.646 0 1.2-.554 1.2-1.2v-2.8c0-.646-.554-1.2-1.2-1.2h-.6v-1.6c0-.646-.554-1.2-1.2-1.2H6c-.646 0-1 .599-1 1.245v8.31c0 .646.354 1.245 1 1.245h16c.646 0 1.2-.554 1.2-1.2Zm-16.6 0c-.058 0-.2-.141-.2-.2v-7.8c0-.059.142-.2.2-.2h15c.059 0 .2.141.2.2v7.8c0 .059-.141.2-.2.2h-15Z"
      fill={fill}
      fillOpacity={1}
    />
  </svg>
);

export default SvgComponent;
